/* File: assets/scrolling-promotion.js */

if (!customElements.get("scrolling-promotion")) {
	class ScrollingPromotion extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			const viewportWidth = window.innerWidth;

			const promo = this.querySelector(".promotion");
			if (!promo) return;

			const singleWidth = promo.getBoundingClientRect().width;
			const cloneCount = Math.ceil((viewportWidth * 2) / singleWidth);
			const originalHTML = promo.innerHTML;
			let allHTML = "";
			for (let i = 0; i < cloneCount; i++) {
				allHTML += originalHTML;
			}
			promo.innerHTML = allHTML;

			promo.style.animation = "none";
			promo.style.transition = "none";
			promo.style.willChange = "transform";

			const isLeft = this.classList.contains("scrolling-promotion--left");
			const direction = isLeft ? -1 : 1;
			const initialOffset = isLeft ? 0 : -singleWidth;
			this.dataset.singleWidth = singleWidth;
			this.dataset.initialOffset = initialOffset;
			this.dataset.direction = direction;

			const speed = parseFloat(this.getAttribute("data-speed")) || 1;
			this.dataset.speedVal = speed;

			this.registerEvents();
		}

		registerEvents() {
			window.addEventListener("scroll", () => {
				const scrollY = window.pageYOffset;

				const promo = this.querySelector(".promotion");
				if (!promo) return;

				const offset = parseFloat(this.dataset.initialOffset) || 0;
				const dir = parseFloat(this.dataset.direction) || 1;
				const speed = parseFloat(this.dataset.speedVal) || 1;

				const scrollOffset = scrollY % this.dataset.singleWidth;

				const translateX = offset + dir * scrollOffset * speed;
				promo.style.transform = `translateX(${translateX}px)`;
			});
		}
	}
	customElements.define("scrolling-promotion", ScrollingPromotion);
}
